import { RightShipMultiLookupModels } from '../../../../components/multi-checked-list-selector/multi-checked-list-selector';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject, transient, computedFrom, observable, BindingEngine } from "aurelia-framework";
import { DataType, DataGridColumn, QueryFilter, SourceType } from "../../../../../models/queries/queries.models";
import { I18N } from "aurelia-i18n";
import { EntityStatusChangeModel, SignalFunctions } from "../../../../../services/basics/signal-functions";
import { SignalClientService } from '@rightship-tech/common-ui/services/basic/signal-client.service';
import { LookupValue, LookupValueRequest } from "../../../../../models/lookups/lookup.models";
import { LookupValueQuery } from "../../../../../constants/modules/lookup.constants";
import * as Enumerable from "linq";
import { IncidentStatusEnum } from "../../../../../models/vetting/vetting.models";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { Reflection } from "../../../../../utilities/reflection";
import { CustomGridPageBase } from "../../../common/custom-grid-page.base";
import { BindingSignaler } from "aurelia-templating-resources";
import { TasksConstants } from "../../../../../models/tasks/task.model";
import { Guid } from "../../../../../utilities/guid";
import KeyDownEvent = JQuery.KeyDownEvent;
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { Claims as CommonUiClaims } from "@rightship-tech/common-ui/constants/authentication/claims";
import { UserClientService } from "../../../../../services/authentication/user-client.service";
import { CustomerService as CommonCustomerService } from "@rightship-tech/common-ui/services/basic/customer-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { IncidentFilters, IncidentActivitiesColumns, ComputedIncidentSeverityEnum } from "../../../../../models/incidents/incident.models";
import { MultiLookupModel } from '../../../../components/multi-checked-list-selector/multi-checked-list-selector';
import { RightShipDialogServiceConstants } from '../../../../../constants/basics/rightship-dialog.constants';
import { RatingItem } from "../../../../components/rating-selector/rating-selector";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { NotificationClientService, NotificationType } from '../../../../../services/basics/notification-client.service';
import { cachable } from '@rightship-tech/common-ui/decorators/cachable';
import { EntityTypeConfigurationHelper } from '@rightship-tech/common-ui/helpers/entity-type-configuration.helper';
import { EntityTypeConfigurationModel } from '@rightship-tech/common-ui/components/comp-entity-finder/comp-entity-finder.models';

@autoinject()
@transient()
export class IncidentActivities extends CustomGridPageBase {

    private _isReloading: boolean;

    public companiesEntityTypes: EntityTypeConfigurationModel[];
    isMobileFilterOpen: boolean;
    cachedMultipleLookups: { [lookup: string]: MultiLookupModel[] } = {};
    @cachable
    mclFilters: { [lookup: string]: QueryFilter[] } = {};
    incidentStatuses: LookupValue[];
    incidentCategories: LookupValue[];
    incidentTypes: LookupValue[];
    incidentZones: LookupValue[];
    allIncidentCategories: LookupValue[];
    allIncidentStatuses: LookupValue[];
    public showStatusFilter: boolean = false;
    public showIncCategoryFilter: boolean = false;
    public showIncFromCategoryFilter: boolean = false;
    public showIncToCategoryFilter: boolean = false;
    @cachable
    private filters: IncidentFilters[] = [];
    public mobileStatusOpen: boolean;
    public mobileIncCategoryOpen: boolean;
    public mobileFromIncCategoryOpen: boolean;
    public mobileToIncCategoryOpen: boolean;
    public mobileIncTypeOpen: boolean
    public mobileVesselAgeOpen: boolean;
    public mobileIncZoneOpen: boolean;
    public mobileSafetyScoreOpen: boolean;
    public mobileSafetyScoreImpactOpen: boolean;
    @cachable
    public statusFilterIds: number[] = [];
    @cachable
    public incCategoryFilterIds: number[] = [];
    @cachable
    public incFromCategoryFilterIds: number[] = [];
    @cachable
    public incToCategoryFilterIds: number[] = [];
    @cachable
    public incTypeFilterIds: number[] = [];
    @cachable
    public incZoneFilterIds: number[] = [];
    public initialFilters: QueryFilter[];
    @cachable
    public rightshipMember: boolean = false;
    public rightShipUser: boolean;
    public canViewVesselAgeInTasks: boolean;
    public canViewIncidentZoneInTasks: boolean;
    public isCustomer: boolean = false;
    public pendingVetCount: number = 0;
    public myIncsCount: number = 0;
    public rightShipMemberCount: number = 0;
    public vettedLast12MthsCount: number = 0;
    public rightShipMemberAndPriorityCount: number = 0;
    public showSafetyRatingFilter: boolean = false;
    public showSafetyScoreImpactFilter: boolean = false;
    public showIncTypeFilter: boolean = false
    public ratings: RatingItem[] = [];
    public canViewVettedInTasks: boolean;
    public canViewSafetyScoreInTasks: boolean;
    public safetyScoreImpactFilters: { name: string, id: number, propertyToFilter: string, selected: boolean, value: boolean }[] = [
        { name: "Active in Safety Score", id: 1, propertyToFilter: 'activeInSafetyScore', selected: false, value: true },
        { name: "Not Active in Safety Score", id: -1, propertyToFilter: 'activeInSafetyScore', selected: false, value: false },
        { name: "Meeting Safety Score Definition", id: 2, propertyToFilter: 'meetsSafetyScoreDefinition', selected: false, value: true },
        { name: "Not Meeting Safety Score Definition", id: -2, propertyToFilter: 'meetsSafetyScoreDefinition', selected: false, value: false }
    ];
    @cachable
    public selectedSafetyScoreImpactFilterIds: number[] = [];
    public canViewSafetyScoreImpactInTasks: boolean;
    public showIncZoneFilter: boolean = false;
    public canViewNotInSafetyScoreInTasks: boolean;
    public canViewCategoryChangesInTasks: boolean;

    vesselTypeDisplayText: string = this.i18N.tr('vessel-type');
    vesselTypeDescription: string = "";
    @cachable
    selectedVesselType: { shipTypeId?: number[], vesselTypeGroupId?: number[] } = {};

    public showDateFilter: boolean = false;
    public mobileDateFilterOpen: boolean = false;
    @cachable
    public dateFilterActive: boolean = false;
    @cachable
    public startDate: Date = null;
    @cachable
    public endDate: Date = null;
    public defaultPageCount: number = 100;

    showVesselAgeFilter: boolean = false;
    vesselAgeDefaults: { low: number, high: number; } = { low: 0, high: 100 };
    @cachable
    vesselAgeFirstFilter: number;
    @cachable
    vesselAgeSecondFilter: number;

    protected get odataUrl() {
        return "odata/Incidents";
    }

    public get filterTypes() {
        return IncidentFilters;
    }

    public get incidentStatusTypes() {
        return IncidentStatusEnum;
    }

    public get incidentCategoryTypes() {
        return ComputedIncidentSeverityEnum;
    }

    @computedFrom(Reflection.getPropertyPath<IncidentActivities>(z => z.vesselAgeFirstFilter),
        Reflection.getPropertyPath<IncidentActivities>(z => z.vesselAgeSecondFilter),
        Reflection.getPropertyPath<IncidentActivities>(z => z.vesselAgeDefaults.low),
        Reflection.getPropertyPath<IncidentActivities>(z => z.vesselAgeDefaults.high))
    public get vesselAgeFilterActive() {
        return this.vesselAgeFirstFilter > this.vesselAgeDefaults.low ||
            this.vesselAgeSecondFilter < this.vesselAgeDefaults.high;
    }

    @computedFrom('selectedSafetyScoreImpactFilterIds', 'selectedSafetyScoreImpactFilterIds.length')
    public get safetyScoreImpactFilterCount() {
        return this.selectedSafetyScoreImpactFilterIds?.length ?? 0;
    }

    @observable()
    @cachable
    filter: string;
    @cachable
    appliedFilter: string;

    filterKeyDown($event) {
        const e: KeyDownEvent = $event.detail;

        if (e.key == "Enter") {
            this.appliedFilter = this.filter;
            this.reloadFilters();
        }
    }

    filterChanged() {
        if ((this.filter && this.filter.length >= 5) || this.filter == "") {
            this.appliedFilter = this.filter;
            this.reloadFilters();
        }
    }

    @cachable
    public selectedSafetyRatings: number[] = [];

    public toggleSafetyRatingFilters($event) {
        if ($event) {
            $event.stopPropagation();
        }

        if (!this.showSafetyRatingFilter) {
            this.closeAllFilters();
        }

        this.showSafetyRatingFilter = !this.showSafetyRatingFilter;
    }

    public clearSafetyRatingFilter($event) {
        if ($event) {
            $event.stopPropagation();
        }
        this.selectedSafetyRatings = [];
        this.reloadFilters();
    }

    public applySafetyRatingFilter($event) {
        this.selectedSafetyRatings = [];
        this.ratings = $event.detail.filters;

        if (this.ratings && this.ratings.length > 0) {
            this.selectedSafetyRatings = this.selectedSafetyRatings.concat(this.ratings.map(x => x.rating));
        }

        this.reloadFilters();

        this.toggleSafetyRatingFilters($event);
    }

    @computedFrom("selectedSafetyRatings", "selectedSafetyRatings.length")
    public get safetyRatingFilterActive() {
        return this.selectedSafetyRatings && this.selectedSafetyRatings.length > 0;
    }

    public toggleSafetyScoreImpactFilters() {
        if (!this.showSafetyScoreImpactFilter) {
            this.closeAllFilters();
        }
        this.showSafetyScoreImpactFilter = !this.showSafetyScoreImpactFilter;
    }

    public clearSafetyScoreImpactFilter() {
        this.selectedSafetyScoreImpactFilterIds = [];
        this.reloadFilters();
    }

    public applySafetyScoreImpactFilter($event) {
        this.selectedSafetyScoreImpactFilterIds = $event.map(e => e.id);
        this.reloadFilters();
        this.showSafetyScoreImpactFilter = false;
    }

    @cachable
    public myIncsFilterSelected: boolean = false;
    myIncsClick(isMobile: boolean = false) {
        this.closeAllFilters();
        this.myIncsFilterSelected = !this.myIncsFilterSelected;
        if (!isMobile) this.reloadFilters();
    }

    //scroll to top of mobile filters
    scrollMobileFilterToTop() {
        const element = document.querySelector('.mobile-filters') as HTMLElement;
        if (element) {
            element.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    clearFilters(reload: boolean = true) {
        if (this.dataGridVM) {
            this.dataGridVM.clearSorting();
        }
        this.filters = [];
        this.incCategoryFilterIds = [];
        this.incFromCategoryFilterIds = [];
        this.incToCategoryFilterIds = [];
        this.incTypeFilterIds = [];
        this.incZoneFilterIds = [];
        this.statusFilterIds = [];
        this.selectedVesselType = null;
        this.mobileIncCategoryIds = [];
        this.mobileIncTypeIds = [];
        this.mobileIncZoneIds = [];
        this.mobileStatusIds = [];
        this.vesselAgeFirstFilter = this.vesselAgeDefaults.low;
        this.vesselAgeSecondFilter = this.vesselAgeDefaults.high;
        this.showVesselAgeFilter = false;
        this.showSafetyScoreImpactFilter = false;
        this.rightshipMember = false;
        this.clearVesselStatusFilter(null);
        this.selectedSafetyRatings = [];
        this.selectedDocCompanies = [];
        this.dwtIsApplied = false;
        this.dwtFirstFilter = null;
        this.dwtSecondFilter = null;
        this.myIncsFilterSelected = false;
        this.dateFilterActive = false;
        this.clearFilter(reload);
        this.clearSafetyScoreImpactFilter();
    }

    public closeAllFilters() {
        this.showStatusFilter = false;
        this.showIncTypeFilter = false;
        this.showIncCategoryFilter = false;
        this.showIncFromCategoryFilter = false;
        this.showIncToCategoryFilter = false;
        this.showSafetyRatingFilter = false;
        this.showSafetyScoreImpactFilter = false;
        this.showDateFilter = false;
        this.showVesselAgeFilter = false;
        this.showIncZoneFilter = false;
        this.showDocCompanyFilter = false;
        this.showDwtFilter = false;
    }

    clearFilter(reload: boolean = true) {
        this.filter = null;
        this.appliedFilter = this.filter;
        if (reload)
            this.reloadFilters();
    }

    //#region Default Filters

    public get isPendingSubtask(): boolean {
        return this.filters.indexOf(IncidentFilters.PendingSubtask) !== -1;
    }

    @computedFrom(Reflection.getPropertyPath<IncidentActivities>(z => z.filters), Reflection.getPropertyPath<IncidentActivities>(z => z.filters.length))
    public get isPendingVet(): boolean {
        return this.filters.indexOf(IncidentFilters.PendingVet) !== -1;
    }

    //#endregion

    @computedFrom("filters", "filters.length")
    public get isVettedLast12Mths(): boolean {
        return this.filters.indexOf(IncidentFilters.VettedLast12Mths) != -1;
    }

    //#region vessel status filter
    public vesselStatusDisplayText: string = this.i18N.tr('vessel-status-text');
    public vesselStatusDescription: string = "";

    public clearVesselStatusFilter(reload: boolean = true) {
        const lookup = LookupValueQuery.VesselStatuses;
        if (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1)
            this.mclFilters[lookup] = [];
        this.vesselStatusDescription = "";
        this.vesselStatusDisplayText = this.i18N.tr('vessel-status-text');
        if (reload)
            this.reloadFilters();
    }

    @computedFrom("mclFilters", "mclFilters.RS_VesselStatuses", "mclFilters.RS_VesselStatuses.length")
    public get vesselStatusFilterActive() {
        const lookup = LookupValueQuery.VesselStatuses;
        return (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1 && this.mclFilters[lookup] && this.mclFilters[lookup].length > 0);
    }
    //#endregion

    openMCLDialog = (type: string) => {
        let lookup = null;

        if (type == "vessel_statuses")
            lookup = LookupValueQuery.VesselStatuses;
        else {
            console.error("invalid multi filter type")
        }
        const displayText = this.i18N.tr('vessel-status-text');

        const cachedMultiLookups = this.cachedMultipleLookups[lookup] ? this.cachedMultipleLookups[lookup] : RightShipMultiLookupModels.getMultiLookupModel(lookup);

        let filterValues: { [filterProperty: string]: number[] } = null;
        if (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1 && this.mclFilters[lookup] && this.mclFilters[lookup].length > 0) {
            filterValues = {};
            this.mclFilters[lookup].forEach(x => {
                filterValues[x.filterProperty.name] = x.filterValue;
            });
        }

        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.MultiCheckedListDialog, {
            multiLookups: cachedMultiLookups,
            title: displayText,
            selectedIds: filterValues,
            onApply: (multiLookups: MultiLookupModel[]) => {

                this.mclFilters[lookup] = [];

                const result = RightShipMultiLookupModels.getMultiLookupFilters(lookup, displayText, multiLookups);

                this.mclFilters[lookup] = result.filters;

                if (lookup == LookupValueQuery.VesselStatuses) {
                    this.vesselStatusDisplayText = result.filterDisplayText;
                    this.vesselStatusDescription = result.filterDescription;
                }

                this.cachedMultipleLookups[lookup] = multiLookups;

                this.reloadFilters();
            }
        }, true, false, false, 'right');
    }

    //#region Status Filters

    public get isStatusNone(): boolean {
        return !this.isStatusCreated
            && !this.isStatusCreated
            && !this.isStatusInProgress
            && !this.isStatusAwaitingResponse
            && !this.isStatusIncidentReassignment
            && !this.isStatusClosed
            && !this.isStatusPendingReview
            && !this.isStatusMisreported;
    }

    public get isStatusCreated(): boolean {
        return this.filters.indexOf(IncidentFilters.Created) !== -1;
    }

    public get isStatusInProgress(): boolean {
        return this.filters.indexOf(IncidentFilters.InProgress) !== -1;
    }

    public get isStatusAwaitingResponse(): boolean {
        return this.filters.indexOf(IncidentFilters.AwaitingResponse) !== -1;
    }

    public get isStatusIncidentReassignment(): boolean {
        return this.filters.indexOf(IncidentFilters.IncidentReassignment) !== -1;
    }

    public get isStatusClosed(): boolean {
        return this.filters.indexOf(IncidentFilters.Closed) !== -1;
    }

    public get isStatusPendingReview(): boolean {
        return this.filters.indexOf(IncidentFilters.PendingReview) !== -1;
    }

    public get isStatusMisreported(): boolean {
        return this.filters.indexOf(IncidentFilters.Misreported) !== -1;
    }

    public getExcludedStatuses(): number[] {
        return [
            IncidentStatusEnum.IncidentReassignment
        ];
    }

    //#endregion

    protected get statusId(): IncidentStatusEnum {
        if (this.isStatusCreated) {
            return IncidentStatusEnum.Created;
        }

        if (this.isStatusInProgress) {
            return IncidentStatusEnum.InProgress;
        }

        if (this.isStatusAwaitingResponse) {
            return IncidentStatusEnum.AwaitingResponse;
        }

        if (this.isStatusIncidentReassignment) {
            return IncidentStatusEnum.IncidentReassignment;
        }

        if (this.isStatusClosed) {
            return IncidentStatusEnum.Closed;
        }

        if (this.isStatusPendingReview) {
            return IncidentStatusEnum.PendingReview;
        }

        if (this.isStatusMisreported) {
            return IncidentStatusEnum.Misreported;
        }

        return null;
    }

    @computedFrom(Reflection.getPropertyName<IncidentActivities>(ia => ia.incidentStatuses))
    public get filterNames() {
        const mappings: { [id: number]: string } = {};

        if (this.incidentStatuses) {
            this.incidentStatuses.forEach(lv => mappings[lv.id] = lv.name);
        }

        return mappings;
    }

    public getSorting() {
        const columns: DataGridColumn[] = [];
        columns.push(
            <DataGridColumn>{
                columnOrder: -1,
                sortOrder: this.rightShipUser ? 3 : 2,
                dataType: DataType.DateTime,
                isSortable: true,
                isAscending: this.rightShipUser ? null : false,
                isHidden: true,
                name: 'submittedDate',
                title: 'SubmittedDate'
            },
            {
                columnOrder: -1,
                sortOrder: 1,
                dataType: DataType.Number,
                isSortable: true,
                isAscending: true,
                isHidden: true,
                name: 'statusRank',
                title: 'StatusRank'
            },
            {
                columnOrder: -1,
                sortOrder: this.rightShipUser ? 2 : 3,
                dataType: DataType.DateTime,
                isSortable: true,
                isAscending: true,
                isHidden: true,
                name: 'statusDate',
                title: 'StatusDate'
            });
        return columns;
    }


    async init() {
        this.rightShipUser = this.userClaimsService.hasPermission(Claims.RightShipUser);
        this.canAccessDueDiligence = this.userClaimsService.hasPermission(CommonUiClaims.CanAccessDueDiligence);
        this.canViewVesselAgeInTasks = this.userClaimsService.hasPermission(Claims.CanViewVesselAgeInTasks);
        this.canViewVettedInTasks = this.userClaimsService.hasPermission(Claims.CanViewVettedInTasks);
        this.canViewIncidentZoneInTasks = this.userClaimsService.hasPermission(Claims.CanViewIncidentZoneInTasks);
        this.canViewCategoryChangesInTasks = this.userClaimsService.hasPermission(Claims.CanViewCategoryChangesInTasks);

        const customerId = this.userClientService.currentUser.settings.customerId;
        this.canViewSafetyScoreInTasks = this.userClaimsService.hasPermission(Claims.CanViewSafetyScoreInTasks);
        this.canViewSafetyScoreImpactInTasks = this.userClaimsService.hasPermission(Claims.CanViewSafetyScoreImpactInTasks);
        if (customerId == null || customerId <= 0) {
            try {
                const c = await this.customerService.getCustomerId()
                this.isCustomer = c && c > 0;
            } catch (e) {
                console.warn(e);
            }
        }
        else this.isCustomer = true;

        this.columns = IncidentActivitiesColumns.getColumns(false, this.rightShipUser, false, this.isCustomer);

        const requestIncidentStatuses = new LookupValueRequest();
        requestIncidentStatuses.lookupValueQuery = LookupValueQuery.IncidentStatuses;
        const x = await this.lookupClientService.getLookup(requestIncidentStatuses);

        let values = x.activeValues;

        if (this.isCustomer) {
            for (const a of values.filter(x => x.isActive)) {
                if (a.name == "Review Required")
                    a.name = "Pending Review";
            }
        }

        this.incidentStatuses = Enumerable.from(values).orderBy(x => x.id).where(x => x.id != IncidentStatusEnum.IncidentReassignment).toArray();
        this.allIncidentStatuses = values;

        const requestIncidentCategories = new LookupValueRequest();
        requestIncidentCategories.lookupValueQuery = LookupValueQuery.ComputedIncidentSeverities;
        const y = await this.lookupClientService.getLookup(requestIncidentCategories);
        values = y.activeValues;
        this.incidentCategories = values;
        this.allIncidentCategories = values;

        const requestIncidentTypes = new LookupValueRequest();
        requestIncidentTypes.lookupValueQuery = LookupValueQuery.CasualtyTypes;
        const z = await this.lookupClientService.getLookup(requestIncidentTypes);
        this.incidentTypes = z.activeValues;

        const requestIncidentZones = new LookupValueRequest();
        requestIncidentZones.lookupValueQuery = LookupValueQuery.IncidentZones;
        const iz = await this.lookupClientService.getLookup(requestIncidentZones);
        this.incidentZones = iz.activeValues;

        this.initialSorting = this.getSorting();
        if (this.applyCache()) {
            this.reloadFilters();
        } else {
            this.setDefaultFilters();
        }
    }
    nameConverterFunc: ((x) => string) = (name) => name == "Review Required" && this.isCustomer ? "Pending Review" : name;

    constructor(i18N: I18N, protected bindingEngine: BindingEngine, private signalClientService: SignalClientService, private lookupClientService: LookupClientService,
        private bindingSignaler: BindingSignaler, private userClaimsService: UserClaimsService, private userClientService: UserClientService, private customerService: CommonCustomerService,
        private queryService: QueriesClientService, private dialogClientService: DialogClientService, private notificationClientService: NotificationClientService,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper) {
        super(i18N, TasksConstants.INCListName, bindingEngine);
        this.companiesEntityTypes = this.entityTypeConfigurationHelper.getConfigurationByKey(["BasicCompanySearch"]);
    }

    async activate() {
        await this.init();
        await this.refreshActivityCounts();
    }

    private setDefaultFilters() {
        this.filters = this.rightShipUser ? [IncidentFilters.PendingVet] : [];
        this.reloadFilters();
    }

    attached() {
        this.signalClientService.subscribeToGroup(SignalFunctions.entityStatusChanged, SignalFunctions.entityTypeGroup(EntityTypes.Incident), this.refreshIncidentStatus);
    }

    detached() {
        this.signalClientService.unsubscribeToGroup(SignalFunctions.entityStatusChanged, SignalFunctions.entityTypeGroup(EntityTypes.Incident), this.refreshIncidentStatus);
        super.detached();
    }

    public toggleVesselAgeFilters() {
        if (!this.showVesselAgeFilter) {
            this.closeAllFilters();
        }
        this.showVesselAgeFilter = !this.showVesselAgeFilter;
    }

    applyVesselAgeFilter(reload: boolean = true) {
        if (reload) {
            this.reloadFilters();

            this.showVesselAgeFilter = false;
        }
    }

    refreshIncidentStatus = async (param: EntityStatusChangeModel) => {
        if (this._isReloading) {
            console.log('refreshIncidentStatus is already in progress, skipping...');
            return;
        }

        try {
            if (this.dataGridVM) {
                this._isReloading = true;
                if (this.dataGridVM.page == 0) {
                    await this.dataGridVM.reloadData();
                } else {
                    const item = this.dataGridVM.itemsCollection.filter(x => x.item.incidentId == param.entityId)[0];
                    if (item) {
                        item.item.statusId = param.statusId;
                        item.item.status = this.incidentStatuses.filter(x => x.id == param.statusId).map(x => x.name)[0];
                    }
                }
                await this.refreshActivityCounts();
            }
        }
        finally {
            this._isReloading = false;
        }
    }

    toggleStatusFilters() {
        if (!this.showStatusFilter) {
            this.closeAllFilters();
        }
        this.showStatusFilter = !this.showStatusFilter;
    }

    onStatusFilter(event) {
        this.statusFilterIds = event.filters.map(x => x.id);
        this.reloadFilters();
        this.showStatusFilter = false;
    }

    toggleIncCategoryFilters() {
        if (!this.showIncCategoryFilter) {
            this.closeAllFilters();
        }
        this.showIncCategoryFilter = !this.showIncCategoryFilter;
    }

    toggleFromIncCategoryFilters() {
        if (!this.showIncFromCategoryFilter) {
            this.closeAllFilters();
        }
        this.showIncFromCategoryFilter = !this.showIncFromCategoryFilter;
    }

    toggleToIncCategoryFilters() {
        if (!this.showIncToCategoryFilter) {
            this.closeAllFilters();
        }
        this.showIncToCategoryFilter = !this.showIncToCategoryFilter;
    }

    toggleIncTypeFilters() {
        if (!this.showIncTypeFilter) {
            this.closeAllFilters();
        }
        this.showIncTypeFilter = !this.showIncTypeFilter;
    }

    toggleIncZoneFilters() {
        if (!this.showIncZoneFilter) {
            this.closeAllFilters();
        }
        this.showIncZoneFilter = !this.showIncZoneFilter;
    }

    onIncCategoryFilter(event) {
        this.incCategoryFilterIds = event.filters.map(x => x.id);
        this.reloadFilters();
        this.showIncCategoryFilter = false;
    }

    onIncFromCategoryFilter(event) {
        this.incFromCategoryFilterIds = event.filters.map(x => x.id);
        this.reloadFilters();
        this.showIncFromCategoryFilter = false;
    }

    onIncToCategoryFilter(event) {
        this.incToCategoryFilterIds = event.filters.map(x => x.id);
        this.reloadFilters();
        this.showIncToCategoryFilter = false;
    }

    onIncTypeFilter(event) {
        this.incTypeFilterIds = event.filters.map(x => x.id);
        this.reloadFilters();
        this.showIncTypeFilter = false;
    }

    onIncZoneFilter(event) {
        this.incZoneFilterIds = event.filters.map(x => x.id);
        this.reloadFilters();
        this.showIncZoneFilter = false;
    }

    clearStatusFilter() {
        this.statusFilterIds = [];
        this.reloadFilters();
    }

    clearIncTypeFilter() {
        this.incTypeFilterIds = [];
        this.reloadFilters();
    }

    clearIncCategoryFilter() {
        this.incCategoryFilterIds = [];
        this.reloadFilters();
    }

    clearIncFromCategoryFilter() {
        this.incFromCategoryFilterIds = [];
        this.reloadFilters();
    }

    clearIncToCategoryFilter() {
        this.incToCategoryFilterIds = [];
        this.reloadFilters();
    }

    clearVesselAgeFilter() {
        this.vesselAgeFirstFilter = this.vesselAgeDefaults.low;
        this.vesselAgeSecondFilter = this.vesselAgeDefaults.high;
        this.reloadFilters();
    }

    clearIncZoneFilter() {
        this.incZoneFilterIds = [];
        this.reloadFilters();
    }

    public setFilter(filter: IncidentFilters) {
        this.closeAllFilters();
        if (!this.filters)
            this.filters = [];

        const index = this.filters.indexOf(filter);
        if (index != -1)
            this.filters.splice(index, 1);
        else
            this.filters.push(filter);

        this.reloadFilters();
    }

    @computedFrom('statusFilterIds', 'statusFilterIds.length')
    public get statusFilterCount() {
        return this.statusFilterIds ? this.statusFilterIds.length : 0;
    }

    @computedFrom('incCategoryFilterIds', 'incCategoryFilterIds.length')
    public get incCategoryFilterCount() {
        return this.incCategoryFilterIds ? this.incCategoryFilterIds.length : 0;
    }

    @computedFrom('incFromCategoryFilterIds', 'incFromCategoryFilterIds.length')
    public get incFromCategoryFilterCount() {
        return this.incFromCategoryFilterIds ? this.incFromCategoryFilterIds.length : 0;
    }

    @computedFrom('incToCategoryFilterIds', 'incToCategoryFilterIds.length')
    public get incToCategoryFilterCount() {
        return this.incToCategoryFilterIds ? this.incToCategoryFilterIds.length : 0;
    }

    @computedFrom('incTypeFilterIds', 'incTypeFilterIds.length')
    public get incTypeFilterCount() {
        return this.incTypeFilterIds ? this.incTypeFilterIds.length : 0;
    }

    @computedFrom('incZoneFilterIds', 'incZoneFilterIds.length')
    public get incZoneFilterCount() {
        return this.incZoneFilterIds ? this.incZoneFilterIds.length : 0;
    }

    @computedFrom("filters", "filters.length")
    public get isNotInSafetyScore(): boolean {
        return this.filters.indexOf(IncidentFilters.NotInSafetyScore) != -1;
    }

    rightshipMemberClick(isMobile: boolean = false) {
        this.closeAllFilters();
        this.rightshipMember = !this.rightshipMember;
        if (!isMobile) this.reloadFilters();
    }

    public reloadFilters() {

        if (!this.columns || this.columns.length <= 0) {
            this.columns = IncidentActivitiesColumns.getColumns(false, this.rightShipUser, false, this.isCustomer);
        }

        const initialFilters = [];

        const guid = Guid.generateGuid();

        if (this.myIncsFilterSelected) {
            if (this.isCustomer) {
                initialFilters.push(QueryFilter.getQuery("subtaskCloseoutUserId", this.userClientService.currentUser.id, "eq", DataType.Number, true));
            } else {
                initialFilters.push(QueryFilter.getQuery("reviewrId", this.userClientService.currentUser.id, "eq", DataType.Number, true));

                initialFilters.push(QueryFilter.getQuery("statusId", [
                    IncidentStatusEnum.Created,
                    IncidentStatusEnum.InProgress,
                    IncidentStatusEnum.AwaitingResponse,
                    IncidentStatusEnum.PendingReview,
                    IncidentStatusEnum.IncidentReassignment
                ], "{0} in ({1})", DataType.Number, true, false, null, false, true));
            }
        }

        if (this.isPendingSubtask && !this.isCustomer) {
            initialFilters.push(QueryFilter.getQuery("pendingSubtask", this.isPendingSubtask, "eq", DataType.Boolean, true, false, guid, true))
        }

        if (this.isPendingVet && !this.isCustomer) {
            initialFilters.push(QueryFilter.getQuery("hasVet", this.isPendingVet, "eq", DataType.Boolean, true, false, guid, true));
        }

        if (this.pendingDueDiligenceFilterActive && this.dueDiligenceFilterVisible) {
            const guid = Guid.generateGuid();
            initialFilters.push(QueryFilter.getQuery("hasDueDiligence", this.pendingDueDiligenceFilterActive, "eq", DataType.Boolean, true, false, guid, true));
        }

        if (this.isVettedLast12Mths && this.rightShipUser && this.canViewVettedInTasks) {
            initialFilters.push(QueryFilter.getQuery("hasVetsInLast12Months", this.isVettedLast12Mths, "eq", DataType.Boolean, true, false, guid, true));
        }

        if (this.statusFilterIds && this.statusFilterIds.length > 0) {
            const statusIdFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "statusId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_IncidentStatuses",
                    isNullable: true,
                },
                filterValue: this.statusFilterIds || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            initialFilters.push(statusIdFilter);
        }

        if (this.incCategoryFilterIds && this.incCategoryFilterIds.length > 0) {
            const incCategoryIdFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "computedSeverityId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_ComputedIncidentSeverities",
                    isNullable: true,
                },
                filterValue: this.incCategoryFilterIds || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            initialFilters.push(incCategoryIdFilter);
        }

        if (this.incFromCategoryFilterIds && this.incFromCategoryFilterIds.length > 0) {
            const incFromCategoryIdFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "fromComputedSeverityId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_ComputedIncidentSeverities",
                    isNullable: true,
                },
                filterValue: this.incFromCategoryFilterIds || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            initialFilters.push(incFromCategoryIdFilter);
        }

        if (this.incToCategoryFilterIds && this.incToCategoryFilterIds.length > 0) {
            const incToCategoryIdFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "toComputedSeverityId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_ComputedIncidentSeverities",
                    isNullable: true,
                },
                filterValue: this.incToCategoryFilterIds || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            initialFilters.push(incToCategoryIdFilter);
        }

        if (this.incTypeFilterIds && this.incTypeFilterIds.length > 0) {
            const incTypeIdFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "casualtyTypeId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_CasualtyTypes",
                    isNullable: true,
                },
                filterValue: this.incTypeFilterIds || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            initialFilters.push(incTypeIdFilter);
        }

        if (this.incZoneFilterIds && this.incZoneFilterIds.length > 0) {
            const incZoneIdFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "incidentZoneId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_IncidentZones",
                    isNullable: true,
                },
                filterValue: this.incZoneFilterIds || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            initialFilters.push(incZoneIdFilter);
        }

        if (this.selectedSafetyRatings && this.selectedSafetyRatings.length > 0 && this.canViewSafetyScoreInTasks) {
            const guid = Guid.generateGuid();
            const hasSafetyRating: boolean = this.selectedSafetyRatings.filter(x => x >= 0).length > 0;
            if (hasSafetyRating) {
                const safetyRatingFilter: QueryFilter = {
                    filterOperator: {
                        translatedSymbol: "{0} in ({1})",
                        friendlyName: "in",
                        requiresFilterValue: true,
                        requiresInterpolation: true
                    },
                    filterProperty: {
                        name: "safetyRating",
                        isDynamicProperty: false,
                        type: DataType.Number,
                        isNullable: true,
                    },
                    filterValue: this.selectedSafetyRatings.filter(x => x >= 0),
                    isAnd: true,
                    skipOnNullOrEmpty: true,
                    groupGuid: guid
                };
                initialFilters.push(safetyRatingFilter);
            }

            const isIncludeNa: boolean = this.selectedSafetyRatings.indexOf(-1) >= 0;
            if (isIncludeNa) {
                const naFilter: QueryFilter = {
                    filterOperator: {
                        translatedSymbol: "{0} in ({1})",
                        friendlyName: "in",
                        requiresFilterValue: true,
                        requiresInterpolation: true
                    },
                    filterProperty: {
                        name: "safetyRatingType",
                        isDynamicProperty: false,
                        type: DataType.Number,
                        isNullable: true,
                    },
                    filterValue: [-1],
                    isAnd: hasSafetyRating ? false : true,
                    skipOnNullOrEmpty: true,
                    groupGuid: guid
                };
                initialFilters.push(naFilter);
            }
            else if (hasSafetyRating) {
                const naFilter: QueryFilter = {
                    filterOperator: {
                        translatedSymbol: "{0} in ({1}) eq false",
                        friendlyName: "not in",
                        requiresFilterValue: true,
                        requiresInterpolation: true
                    },
                    filterProperty: {
                        name: "safetyRatingType",
                        isDynamicProperty: false,
                        type: DataType.Number,
                        isNullable: true,
                    },
                    filterValue: [-1],
                    isAnd: true,
                    skipOnNullOrEmpty: true,
                    groupGuid: guid
                };
                initialFilters.push(naFilter);
            }
        }

        if (this.selectedSafetyScoreImpactFilterIds?.length > 0) {
            this.selectedSafetyScoreImpactFilterIds.forEach(x => {
                if (this.selectedSafetyScoreImpactFilterIds.indexOf(-x) < 0) {
                    const selectedFilter = this.safetyScoreImpactFilters.find(s => s.id === x);
                    initialFilters.push(QueryFilter.getQuery(selectedFilter.propertyToFilter, selectedFilter.value, "eq", DataType.Boolean, true, false, guid, true));
                }
            });
        }

        if (this.showVesselAgeFilter || this.vesselAgeFilterActive) {
            const guid = Guid.generateGuid();
            initialFilters.push(QueryFilter.getQuery("vesselAge", this.vesselAgeFirstFilter, "ge", DataType.Number, true, false, guid, true, false));
            initialFilters.push(QueryFilter.getQuery("vesselAge", this.vesselAgeSecondFilter, "le", DataType.Number, true, true, guid, true, false));
        }

        if (this.appliedFilter) {
            const guid = Guid.generateGuid();
            initialFilters.push(QueryFilter.getQuery("vesselName", this.appliedFilter, "contains({0}, '{1}')", DataType.Default, true, false, guid, true, true));
            initialFilters.push(QueryFilter.getQuery("vesselImo", this.appliedFilter, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true));
            initialFilters.push(QueryFilter.getQuery("incIdStr", this.appliedFilter, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true));
        }

        if (this.rightshipMember && !this.isCustomer) {
            const guid = Guid.generateGuid();
            initialFilters.push(QueryFilter.getQuery("isRightShipMember", true, "eq", DataType.Boolean, true, false, guid, true));
            initialFilters.push(QueryFilter.getQuery("isPriority", true, "eq", DataType.Boolean, false, true, guid, true));
        }

        if (this.vesselStatusFilterActive) {
            this.mclFilters[LookupValueQuery.VesselStatuses].forEach(status => {
                initialFilters.push(status);
            });
        }

        if (this.vesselTypeFilterActive) {
            const guid = Guid.generateGuid();
            const hasVesselTypeGroups = this.selectedVesselType.vesselTypeGroupId && this.selectedVesselType.vesselTypeGroupId.length > 0;

            initialFilters.push(QueryFilter.getQuery("vesselTypeGroupId", this.selectedVesselType.vesselTypeGroupId ?? [], '{0} in ({1})', DataType.Number, true, false, guid, true, true))
            //if has only vessel types and no vessel type group the filter should be added with isAnd true
            initialFilters.push(QueryFilter.getQuery("vesselTypeId", this.selectedVesselType.shipTypeId ?? [], '{0} in ({1})', DataType.Number, !hasVesselTypeGroups, false, guid, true, true))
        }

        if (this.dateFilterActive) {
            const incidentDateGuid = Guid.generateGuid();

            initialFilters.push(QueryFilter.getQuery("incidentDate", this.startDate, 'ge', DataType.Date, true, false, incidentDateGuid, true, false))
            initialFilters.push(QueryFilter.getQuery("incidentDate", this.endDate, 'le', DataType.Date, true, true, incidentDateGuid, true, false))
        }
        
        //#region doc company
        if (this.docCompanyFilterActive) {

            const docCompanyFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "docCompanyId",
                    isDynamicProperty: false,
                    type: DataType.Number,
                    isNullable: true,
                },
                filterValue: this.selectedDocCompanies || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            initialFilters.push(docCompanyFilter);
        }
        //#endregion

        //#region dwt
        if (this.dwtFirstFilter || this.dwtSecondFilter) {
            initialFilters.push(QueryFilter.getQuery('dwt', this.dwtFirstFilter ? this.dwtFirstFilter : 0, 'ge', DataType.Number, true));
            initialFilters.push(QueryFilter.getQuery('dwt', this.dwtSecondFilter ? this.dwtSecondFilter : 0, 'le', DataType.Number, true));
        }
        //#endregion

        this.initialFilters = initialFilters;
        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: this.odataUrl,
            columns: this.columns,
            initialFilters: initialFilters,
            initialSorting: this.initialSorting
        };
    }

    async refreshActivityCounts() {
        if (this.userClaimsService.hasPermission(Claims.CanAccessINCs)) {
            const x = await this.queryService.getData(`${this.odataUrl}/Genesis.GetStatusCounts()`);

            this.clearCounts();
            for (let i = 0; i < x.keys.length; ++i) {

                const key = x.keys[i];
                const value = x.values[i];

                if (key == 'pendingVets') {
                    this.pendingVetCount = value;
                } else if (key == 'myIncs') {
                    this.myIncsCount = value;
                } else if (key == 'rightShipMemberAndPriority') {
                    this.rightShipMemberAndPriorityCount = value;
                } else if (key == "pendingDueDiligence") {
                    this.pendingDueDiligenceCount = value;
                }
            }
        }
    }

    clearCounts() {
        this.pendingVetCount = 0;
        this.myIncsCount = 0;
        this.rightShipMemberAndPriorityCount = 0;
        this.pendingDueDiligenceCount = 0;
    }

    toggleMobileFilterDialog() {
        this.isMobileFilterOpen = !this.isMobileFilterOpen;
    }

    openMobileStatus() {
        this.mobileStatusOpen = true;
    }

    closedMobileStatus() {
        this.mobileStatusOpen = false;
    }

    openMobileIncCategory() {
        this.mobileIncCategoryOpen = true;
    }

    closedMobileIncCategory() {
        this.mobileIncCategoryOpen = false;
    }

    openMobileFromIncCategory() {
        this.mobileFromIncCategoryOpen = true;
    }

    closedMobileFromIncCategory() {
        this.mobileFromIncCategoryOpen = false;
    }

    openMobileToIncCategory() {
        this.mobileToIncCategoryOpen = true;
    }

    closedMobileToIncCategory() {
        this.mobileToIncCategoryOpen = false;
    }

    openMobileIncType() {
        this.mobileIncTypeOpen = true;
    }

    closedMobileIncType() {
        this.mobileIncTypeOpen = false;
    }

    openDateMobileFilter() {
        this.mobileDateFilterOpen = true;
    }

    closeDateMobileFilter() {
        this.mobileDateFilterOpen = false;
    }

    openMobileVesselAge() {
        this.mobileVesselAgeOpen = true;
        this.showVesselAgeFilter = !this.showVesselAgeFilter;
    }

    closedMobileVesselAge() {
        this.mobileVesselAgeOpen = false;
    }

    openMobileIncZone() {
        this.mobileIncZoneOpen = true;
    }

    closedMobileIncZone() {
        this.mobileIncZoneOpen = false;
    }

    openMobileSafetyScore() {
        this.mobileSafetyScoreOpen = true;
        this.showSafetyRatingFilter = !this.showSafetyRatingFilter;
    }

    closedMobileSafetyScore() {
        this.mobileSafetyScoreOpen = false;
    }

    openMobileSafetyStoreImpact() {
        this.mobileSafetyScoreImpactOpen = true;
        this.showSafetyScoreImpactFilter = !this.showSafetyScoreImpactFilter;
    }

    closeMobileSafetyScore() {
        this.mobileSafetyScoreImpactOpen = false;
    }

    private mobileStatusIds: number[] = [];
    private mobileIncZoneIds: number[] = [];
    private mobileIncCategoryIds: number[] = [];
    private mobileFromIncCategoryIds: number[] = [];
    private mobileToIncCategoryIds: number[] = [];
    public mobileIncTypeIds: number[] = [];

    mobileStatusClick(value: LookupValue) {
        const existingIndex = this.mobileStatusIds.indexOf(value.id);

        if (existingIndex > -1) {
            this.mobileStatusIds.splice(existingIndex, 1);
        } else {
            this.mobileStatusIds.push(value.id);
        }

        this.statusFilterIds = this.mobileStatusIds;

        this.bindingSignaler.signal('mobileStatusChange');
    }

    mobileIncCategoryClick(value: LookupValue) {
        const existingIndex = this.mobileIncCategoryIds.indexOf(value.id);

        if (existingIndex > -1) {
            this.mobileIncCategoryIds.splice(existingIndex, 1);
        } else {
            this.mobileIncCategoryIds.push(value.id);
        }

        this.incCategoryFilterIds = this.mobileIncCategoryIds;

        this.bindingSignaler.signal('mobileIncCategoryChange');
        this.clearVesselStatusFilter(null);
    }

    mobileFromIncCategoryClick(value: LookupValue) {
        const existingIndex = this.mobileFromIncCategoryIds.indexOf(value.id);

        if (existingIndex > -1) {
            this.mobileFromIncCategoryIds.splice(existingIndex, 1);
        } else {
            this.mobileFromIncCategoryIds.push(value.id);
        }

        this.incFromCategoryFilterIds = this.mobileFromIncCategoryIds;

        this.bindingSignaler.signal('mobileFromIncCategoryChange');
        this.clearVesselStatusFilter(null);
    }

    mobileToIncCategoryClick(value: LookupValue) {
        const existingIndex = this.mobileToIncCategoryIds.indexOf(value.id);

        if (existingIndex > -1) {
            this.mobileToIncCategoryIds.splice(existingIndex, 1);
        } else {
            this.mobileToIncCategoryIds.push(value.id);
        }

        this.incToCategoryFilterIds = this.mobileToIncCategoryIds;

        this.bindingSignaler.signal('mobileToIncCategoryChange');
        this.clearVesselStatusFilter(null);
    }

    mobileIncTypeClick(value: LookupValue) {
        const existingIndex = this.mobileIncTypeIds.indexOf(value.id);

        if (existingIndex > -1) {
            this.mobileIncTypeIds.splice(existingIndex, 1);
        } else {
            this.mobileIncTypeIds.push(value.id);
        }

        this.incTypeFilterIds = this.mobileIncTypeIds;

        this.bindingSignaler.signal('mobileIncTypeChange');
        this.clearVesselStatusFilter(null);
    }

    mobileSafetyScoreImpactClick(id: number) {
        const existingSelectedSafetyScoreImpactIdIdex = this.selectedSafetyScoreImpactFilterIds.indexOf(id);
        const existingSafetyScoreImpact = this.safetyScoreImpactFilters.find(s => s.id === id);
        existingSafetyScoreImpact.selected = !existingSafetyScoreImpact.selected;

        if (existingSelectedSafetyScoreImpactIdIdex > -1) {
            this.selectedSafetyScoreImpactFilterIds.splice(existingSelectedSafetyScoreImpactIdIdex, 1);
        } else {
            this.selectedSafetyScoreImpactFilterIds.push(id);
        }
    }

    mobileIncZoneClick(value: LookupValue) {
        const existingIndex = this.mobileIncZoneIds.indexOf(value.id);

        if (existingIndex > -1) {
            this.mobileIncZoneIds.splice(existingIndex, 1);
        } else {
            this.mobileIncZoneIds.push(value.id);
        }

        this.incZoneFilterIds = this.mobileIncZoneIds;

        this.bindingSignaler.signal('mobileIncZoneChange');
        this.clearVesselStatusFilter(null);
    }

    public isMobileIncCategorySelected(id: number) {
        return this.mobileIncCategoryIds.indexOf(id) > -1;
    }

    public isMobileFromIncCategorySelected(id: number) {
        return this.mobileFromIncCategoryIds.indexOf(id) > -1;
    }

    public isMobileToIncCategorySelected(id: number) {
        return this.mobileToIncCategoryIds.indexOf(id) > -1;
    }

    public isMobileIncTypeSelected(id: number) {
        return this.mobileIncTypeIds.indexOf(id) > -1;
    }

    public isMobileStatusSelected(id: number) {
        return this.mobileStatusIds.indexOf(id) > -1;
    }

    public isMobileIncZoneSelected(id: number) {
        return this.mobileIncZoneIds.indexOf(id) > -1;
    }

    public setMobileFilter(filter: IncidentFilters) {
        if (!this.filters)
            this.filters = [];

        const index = this.filters.indexOf(filter);
        if (index != -1)
            this.filters.splice(index, 1);
        else
            this.filters.push(filter);
    }

    public onMobileApply() {
        if (this.mobileVesselAgeOpen) {
            this.mobileVesselAgeOpen = false;
        }
        else if (this.mobileIncCategoryOpen) {
            this.mobileIncCategoryOpen = false;
        }
        else if (this.mobileFromIncCategoryOpen) {
            this.mobileFromIncCategoryOpen = false;
        }
        else if (this.mobileToIncCategoryOpen) {
            this.mobileToIncCategoryOpen = false;
        }
        else if (this.mobileIncTypeOpen) {
            this.mobileIncTypeOpen = false;
        }
        else if (this.mobileIncZoneOpen) {
            this.mobileIncZoneOpen = false;
        }
        else if (this.mobileDateFilterOpen) {
            this.applyDateFilter({ closeFilter: true })
            this.mobileDateFilterOpen = false
        }
        else if (this.mobileSafetyScoreOpen) {
            this.mobileSafetyScoreOpen = false;
        }
        else if (this.mobileStatusOpen) {
            this.mobileStatusOpen = false;
        } else if (this.mobileSafetyScoreImpactOpen) {
            this.mobileSafetyScoreImpactOpen = false;
        } else {
            this.toggleMobileFilterDialog();
        }

        this.reloadFilters();
    }

    clearAllMobile() {
        this.statusFilterIds = [];
        this.mobileStatusIds = [];
        this.incCategoryFilterIds = [];
        this.mobileIncCategoryIds = [];
        this.incFromCategoryFilterIds = [];
        this.mobileFromIncCategoryIds = [];
        this.incToCategoryFilterIds = [];
        this.mobileToIncCategoryIds = [];
        this.mobileIncTypeIds = [];
        this.mobileIncZoneIds = [];
        this.startDate = null;
        this.endDate = null;
        this.dateFilterActive = false;
        this.selectedVesselType = null;
        this.filters = [];
        this.vesselAgeFirstFilter = null;
        this.vesselAgeSecondFilter = null;
        this.vesselAgeFirstFilter = this.vesselAgeDefaults.low;
        this.vesselAgeSecondFilter = this.vesselAgeDefaults.high;
        this.showVesselAgeFilter = false;
        this.showSafetyRatingFilter = false;
        this.showSafetyScoreImpactFilter = false;
        this.rightshipMember = false;
        this.selectedSafetyRatings = [];
        this.showDocCompanyFilter = false;
        this.selectedDocCompanies = [];
        this.showDwtFilter = false;
        this.dwtIsApplied = false;
        this.dwtFirstFilter = null;
        this.dwtSecondFilter = null;
        this.bindingSignaler.signal('mobileStatusChange');
        this.bindingSignaler.signal('mobileIncCategoryChange');
        this.selectedSafetyScoreImpactFilterIds = [];
        this.bindingSignaler.signal('mobileFromIncCategoryChange');
        this.bindingSignaler.signal('mobileToIncCategoryChange');
    }

    public getExcludedIncCategory(): number[] {
        const excludeIncCategories: number[] = [];
        const canViewCatUIncidents = this.userClaimsService.hasPermission(Claims.CanViewCatUIncidents);
        if (!canViewCatUIncidents) {
            const excldueList = this.incidentCategories.filter(x => x.name == "Category U");
            if (excldueList && excldueList.length > 0) {
                excludeIncCategories.push(...excldueList.map(x => x.id));
            }
        }
        return excludeIncCategories;
    }

    openVesselTypesDialog() {
        const lookup = LookupValueQuery.VesselTypes;
        const displayText = this.i18N.tr('vessel-type');
        const cachedMultiLookups = this.cachedMultipleLookups[lookup] ? this.cachedMultipleLookups[lookup] : RightShipMultiLookupModels.getMultiLookupModel(lookup);
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.MultiCheckedListDialog, {
            multiLookups: cachedMultiLookups,
            title: displayText,
            selectedIds: this.selectedVesselType,
            onApply: (multiLookups: MultiLookupModel[]) => {

                this.selectedVesselType = {};

                const result = RightShipMultiLookupModels.getMultiLookupFilters(lookup, displayText, multiLookups);
                if (result) {
                    for (const filter of result.filters) {
                        this.selectedVesselType[filter.filterProperty.name] = filter.filterValue;
                    }
                }
                this.vesselTypeDisplayText = result.filterDisplayText;
                this.vesselTypeDescription = result.filterDescription;
                this.cachedMultipleLookups[lookup] = multiLookups;
                this.reloadFilters();
            }
        }, true, false, false, 'right');
    }

    @computedFrom(Reflection.getPropertyPath<IncidentActivities>(z => z.selectedVesselType),
        Reflection.getPropertyPath<IncidentActivities>(z => z.selectedVesselType.vesselTypeGroupId),
        Reflection.getPropertyPath<IncidentActivities>(z => z.selectedVesselType.vesselTypeGroupId.length),
        Reflection.getPropertyPath<IncidentActivities>(z => z.selectedVesselType.shipTypeId),
        Reflection.getPropertyPath<IncidentActivities>(z => z.selectedVesselType.shipTypeId.length))
    public get vesselTypeFilterActive() {
        return this.selectedVesselType && ((this.selectedVesselType.vesselTypeGroupId && this.selectedVesselType.vesselTypeGroupId.length > 0) ||
            (this.selectedVesselType.shipTypeId && this.selectedVesselType.shipTypeId.length > 0));
    }

    public toggleDateFilter() {
        if (!this.showDateFilter) {
            this.closeAllFilters();
        }
        this.showDateFilter = !this.showDateFilter
    }


    public applyDateFilter(event) {

        //for clearing the filter
        if (!event.closeFilter) {
            this.dateFilterActive = false;
            this.showDateFilter = false;
            this.reloadFilters();
            return;
        }

        if (!this.startDate && !this.endDate) {
            this.notificationClientService.show("Can't Apply Filter", "Cannot leave Start or End date empty", NotificationType.Error);
            return;
        }
        if (this.startDate >= this.endDate) {
            this.notificationClientService.show("Can't Apply Filter", "Start Date can't be greater than End Date", NotificationType.Error);
            return;
        }

        this.dateFilterActive = true;
        this.showDateFilter = false;
        this.reloadFilters();
    }

    hideMobileFilters() {
        this.isMobileFilterOpen = false;
    }

    //#region doc company filter
    public showDocCompanyFilter: boolean = false;
    @cachable
    public selectedDocCompanies: number[] = [];

    public toggleDocCompanyFilters() {
        if (!this.showDocCompanyFilter) {
            this.closeAllFilters();
        }
        this.showDocCompanyFilter = !this.showDocCompanyFilter;
    }

    public applyDocCompanyFilter(items: any[], reload: boolean = true) {
        if (!items) {
            return;
        }
        this.selectedDocCompanies = items.map(x => x.id);
        if (reload == true) this.reloadFilters();
        this.toggleDocCompanyFilters();
    }

    public clearDocCompanyFilter() {
        this.selectedDocCompanies = [];
        this.reloadFilters();
    }

    @computedFrom("selectedDocCompanies", "selectedDocCompanies.length")
    public get docCompanyFilterActive() {
        return this.selectedDocCompanies?.length > 0 && this.selectedDocCompanies[0] != null;
    }

    //#endregion

    //#region dwt filter
    @cachable
    public dwtFirstFilter: number;
    @cachable
    public dwtSecondFilter: number;
    public dwtDefaults: { low: number, high: number } = { low: 0, high: 565000 };
    public showDwtFilter: boolean = false;
    public dwtIsApplied: boolean = false;

    public toggleDwtFilters() {
        if (!this.showDwtFilter) {
            this.closeAllFilters();
        }
        this.showDwtFilter = !this.showDwtFilter;
    }

    public applyDwtFilter(filterValue: { low: number, high: number } = null) {
        if (filterValue) {
            this.dwtFirstFilter = filterValue.low;
            this.dwtSecondFilter = filterValue.high;
            this.dwtIsApplied = true;
        }

        this.reloadFilters();
        this.toggleDwtFilters();
    }

    public clearDwtFilter() {
        this.dwtFirstFilter = null;
        this.dwtSecondFilter = null;
        this.dwtIsApplied = false;
        this.reloadFilters();
    }

    @computedFrom("dwtIsApplied", "dwtFirstFilter", "dwtSecondFilter")
    public get dwtFilterActive() {
        return this.dwtIsApplied && ((this.dwtFirstFilter && this.dwtFirstFilter >= this.dwtDefaults.low) || (this.dwtSecondFilter && this.dwtSecondFilter <= this.dwtDefaults.high));
    }

    //#endregion

    //#region due diligence filter
    
    public pendingDueDiligenceCount: number = 0;
    public canAccessDueDiligence: boolean;
    
    @computedFrom(Reflection.getPropertyPath<IncidentActivities>(z => z.canAccessDueDiligence),
        Reflection.getPropertyPath<IncidentActivities>(z => z.rightShipUser))
    public get dueDiligenceFilterVisible(): boolean
    {
        return this.canAccessDueDiligence && this.rightShipUser;
    }

    @computedFrom("filters", "filters.length")
    public get pendingDueDiligenceFilterActive(): boolean {
        return this.filters.indexOf(IncidentFilters.PendingDueDiligence) !== -1;
    }

    //#endregion
}
